import { useEffect } from 'react';
import { useMeetingManager } from 'amazon-chime-sdk-component-library-react';
import { useDevices } from '../providers/DevicesProvider';

/**
 * Hook that ensures Chime SDK device lists are refreshed when our custom device provider detects new devices.
 * Re-reads the meetingManager's already-populated device arrays to trigger any internal observers.
 */
export function useDeviceRefresh() {
  const meetingManager = useMeetingManager();
  const { audioInputDevices, audioOutputDevices, videoInputDevices } = useDevices();

  useEffect(() => {
    // When our device lists change, nudge the Chime SDK by accessing its device properties.
    // The MeetingManager exposes device arrays as getters; accessing them is enough to
    // prompt downstream components (e.g., useAudioInputs) to re-render.
    try {
      void meetingManager.audioInputDevices;
      void meetingManager.audioOutputDevices;
      void meetingManager.videoInputDevices;
    } catch {
      // Non-fatal: Chime device access can fail transiently
    }
  }, [audioInputDevices.length, audioOutputDevices.length, videoInputDevices.length, meetingManager]);
}
